/* Observe initial cart requests so the selection cannot race the cart apps.
 * Requests and responses are passed through unchanged; only this offer waits.
 */
(() => {
  'use strict';
  if (window.jaesaCartNetwork) return;
  let pending = 0;
  let lastFinished = performance.now();
  const isCart = input => {
    try {
      const url = new URL(typeof input === 'string' ? input : input.url, location.href);
      return url.origin === location.origin && /^\/cart(?:\.js|\/(?:add|update|change|clear)(?:\.js)?)?$/.test(url.pathname);
    } catch (_) { return false; }
  };
  const started = () => {
    pending++;
    let finished = false;
    return () => { if (!finished) { finished = true; pending--; lastFinished = performance.now(); } };
  };
  const nativeFetch = window.fetch;
  window.fetch = function (...args) {
    if (!isCart(args[0])) return nativeFetch.apply(this, args);
    const finish = started();
    try { return nativeFetch.apply(this, args).finally(finish); }
    catch (error) { finish(); throw error; }
  };
  const open = XMLHttpRequest.prototype.open;
  const send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url, ...args) {
    this.jaesaCartRequest = isCart(url);
    return open.call(this, method, url, ...args);
  };
  XMLHttpRequest.prototype.send = function (...args) {
    if (!this.jaesaCartRequest) return send.apply(this, args);
    const finish = started();
    this.addEventListener('loadend', finish, {once: true});
    try { return send.apply(this, args); }
    catch (error) { finish(); throw error; }
  };
  window.jaesaCartNetwork = {
    waitForIdle: () => new Promise((resolve, reject) => {
      const since = performance.now();
      const check = () => {
        if (document.readyState === 'complete' && document.querySelector('#kaching-cart .kaching-cart__header') && pending === 0 && performance.now() - lastFinished >= 500) {
          resolve();
        } else if (performance.now() - since > 15000) {
          reject(new Error('Cart initialization did not settle'));
        } else {
          setTimeout(check, 100);
        }
      };
      check();
    })
  };
})();
